module.exports = __webpack_public_path__ + "assets/9b85a4d6c23d58aadcd1bf847c3bca0c.png";